import { ThresholdLevel } from '@vista/diagnostics';
import { Validator } from '@vista-digital/validator';
export const defaultLoggerConfig = {
    thresholdLevel: ThresholdLevel.DEBUG,
    messagePrefix: 'Vista Omnichannel Components'
};
export const loggerConfigValidator = Validator.object({
    thresholdLevel: Validator.oneOf(Object.values(ThresholdLevel)),
    messagePrefix: Validator.nonEmptyString
});
//# sourceMappingURL=logger.js.map